module.exports = __webpack_public_path__ + "static/assets/3ddb6e3f28153f0ecdef48ab7ed42603.png";